//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createFieldConfig, Store } from '../../../../components/QSelectUtils.js'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchConfig: createFieldConfig(new Store({
        fullReadable: false,
        cached: true,
        proxy: {
          urlBase: '/service/delta/serviceobject/search',
          filterType: 'serviceObject',
          formId: 'checkList'
        }
      })),
      selectionDialogColumns: [
        {
          name: 'alias',
          label: 'Название',
          align: 'left',
          defaultWidth: 130,
          field: 'alias',
          sortable: true
        },
        {
          name: 'fvfComplexNumber',
          label: 'Номер комплекса',
          labelTable: 'Номер</br>комплекса',
          align: 'left',
          defaultWidth: 80,
          field: 'fvfComplexNumber',
          sortable: true
        },
        {
          name: 'typeAlias',
          label: 'Тип',
          align: 'left',
          defaultWidth: 40,
          field: 'typeAlias',
          sortable: true
        },
        {
          name: 'address',
          label: 'Адрес',
          align: 'left',
          defaultWidth: 600,
          field: 'address',
          sortable: true
        }
      ]
    }
  },
  computed: {
    value: {
      set: function (val) {
        this.resultValue.value = val ? { id: val.id, name: val.name, type: val.type } : null
      },
      get: function () {
        return this.resultValue.value
      }
    }
  }
}

